import { Navigate, Outlet } from 'react-router-dom';

import { LocaleSwitch } from '../components/locale-switch/LocaleSwitch';
import { ThemeSwitch } from '../components/ThemeSwitch';
import { useTokens } from '../hooks/useTokens';

export const AnonymousLayout = () => {
  const { tokens } = useTokens();

  if (tokens) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <div className="min-h-screen h-auto relative">
      <Outlet />
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <ThemeSwitch />
        <LocaleSwitch />
      </div>
    </div>
  );
};
